// extracted by mini-css-extract-plugin
export default {"container":"OD-z","dimension":"PD-z","dimensionLabels":"QD-z"};